import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const Equipmentshop = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Equipment Shop</h2>
                            <p>
                                The Equipment Shop at Net Nest Badminton Sports Club is a one-stop destination for high-quality badminton gear and accessories. Designed to meet the needs of beginners, intermediate players, and professional athletes, our shop ensures that every player has access to the right equipment to enhance performance, comfort, and safety on the court.
                            </p>
                            <p>
                                Professional and beginner badminton rackets
                                <br></br>
                                Feather and nylon shuttlecocks
                                <br></br>
                                Badminton shoes with proper grip and cushioning
                                <br></br>
                                Grips, strings, wristbands, and headbands
                                <br></br>
                                Badminton bags and protective accessories
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=600" alt="Badminton Court" className="main-image" />
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Trusted Brands & Quality Assurance</h2>
                            <p>
                                We stock equipment from reputed and trusted sports brands known for durability and performance. Every product is quality-checked to ensure players receive reliable gear that supports long-term use and competitive play.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Expert Guidance & Personalized Recommendations</h2>
                            <p>
                                Recommending rackets based on playing style and skill level
                                <br></br>
                                Advising on correct grip size and string tension
                                <br></br>
                                Helping beginners select suitable starter kits
                                <br></br>
                                Assisting advanced players with performance-focused gear
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Racket Stringing & Maintenance Services</h2>
                            <p>
                                Custom string tension as per player requirement
                                <br></br>
                                Grip replacement and re-wrapping
                                <br></br>
                                Basic racket inspection and care tips
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Convenient Access for Players</h2>
                            <p>
                                Located within the Net Nest Badminton Sports Club premises, the equipment shop offers easy access before or after training sessions. Players can quickly replace worn-out gear without leaving the facility.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Affordable Pricing & Value Deals</h2>
                            <p>
                                Competitive and transparent pricing
                                <br></br>
                                Special discounts for academy members
                                <br></br>
                                Combo offers and seasonal promotions
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Equipment for All Age Groups</h2>
                            <p>
                                Young beginners and junior players
                                <br></br>
                                Intermediate and advanced athletes
                                <br></br>
                                Recreational and fitness badminton players
                                <br></br>
                                Professional and tournament-level competitors
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Hygiene & Safety Standards</h2>
                            <p>
                                All equipment is stored and displayed in a clean, organized, and hygienic environment. Safety-focused accessories help reduce the risk of injuries and improve overall playing comfort.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Equipmentshop;
